import { useReducer } from 'react';

const initialState = {
  isOpen: false,
  mode: 'Approve', // either 'Approve' or 'Remove'
  encounterCmsCodeId: []
};

const ACTION_TYPES = {
  OPEN_ADD_REASON_OPTION_DIALOG: 'OPEN_ADD_REASON_OPTION_DIALOG',
  CLOSE_ADD_REASON_OPTION_DIALOG: 'CLOSE_ADD_REASON_OPTION_DIALOG'
};

const ACTIONS = {
  openAddReasonOptionDialog: (mode, encounterCmsCodeId) => ({
    type: ACTION_TYPES.OPEN_ADD_REASON_OPTION_DIALOG,
    payload: {
      mode,
      encounterCmsCodeId
    }
  }),
  closeAddReasonOptionDialog: () => ({
    type: ACTION_TYPES.CLOSE_ADD_REASON_OPTION_DIALOG
  })
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.OPEN_ADD_REASON_OPTION_DIALOG: {
      const { payload: { mode, encounterCmsCodeId } } = action;

      return {
        ...state,
        isOpen: true,
        mode,
        encounterCmsCodeId
      };
    }

    case ACTION_TYPES.CLOSE_ADD_REASON_OPTION_DIALOG: {
      return {
        ...state,
        isOpen: false
      };
    }

    default: {
      throw Error('useAddReasonOptionDialog reducer should never hit default');
    }
  }
};

const useAddReasonOptionDialog = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const open = (mode, encounterCmsCodeId) =>
    dispatch(
      ACTIONS.openAddReasonOptionDialog(mode, encounterCmsCodeId)
    );

  const close = () => dispatch(ACTIONS.closeAddReasonOptionDialog());

  const boundActions = {
    open,
    close
  };

  return [state, boundActions];
};

export default useAddReasonOptionDialog;
